import React, { useEffect, useState } from 'react';
import { Text, Flex, Button } from "@radix-ui/themes";
import Icon from '@mdi/react';
import { mdiChevronRight, mdiPlus } from '@mdi/js';
import { useStore } from '../store/store';
import { api } from '../services/api';
import { useParams } from 'react-router-dom';

export const SidebarNotes = (props) => {
    const [state, actions] = useStore();
    const { selectedNote, setSelectedNote } = props;
    const { novelId } = useParams();
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        const fetchNotes = async () => {
            try {
                setLoading(true);
                const response = await api.getNotesByNovelId(novelId);
                if (response.success) {
                    // Only update the global store
                    if (state.currentNovel) {
                        actions.setCurrentNovel({
                            ...state.currentNovel,
                            notes: response.notes
                        });
                    }
                }
            } catch (error) {
                console.error("Error fetching notes:", error);
            } finally {
                setLoading(false);
            }
        };

        // Only fetch notes if they're not already in the store
        if (!state.currentNovel?.notes) {
            fetchNotes();
        } else {
            setLoading(false);
        }
    }, [novelId, state.currentNovel?.id]);

    const handleNewNote = () => {
        setSelectedNote({ new: true, title: 'New Note', content: '' });
    };

    const notesList = state.currentNovel?.notes?.map(note => {
        return (
            <div key={note.id} className="sidebar-character-item" onClick={() => {
                if (selectedNote?.id === note?.id) {
                    setSelectedNote(null);
                } else {
                    setSelectedNote(note);
                }
            }}>
                <Flex justify={'between'} align={'center'}>
                    <Flex direction="column" align={'start'}>
                        <Text as='div' size={"3"}>{note.title}</Text>
                        {note.content && <Text as='div' size={"1"} style={{ opacity: 0.7 }}>
                            {note.content.substring(0, 40)}{note.content.length > 40 ? '...' : ''}
                        </Text>}
                    </Flex>
                    {selectedNote?.id === note?.id ? <Icon path={mdiChevronRight} size={1}/> : null}
                </Flex>
            </div>
        );
    });

    if (loading) {
        return <div>Loading notes...</div>;
    }

    return (
        <div>
            {state.currentNovel?.notes && state.currentNovel.notes.length > 0 ? (
                notesList
            ) : (
                <Text size="2" style={{ opacity: 0.7, padding: "10px 0", cursor: "default" }}>
                    No notes yet. Create your first note!
                </Text>
            )}
            
            <div className="sidebar-add-new-button-wrapper">
                {!state.readOnly && <Button className="sidebar-add-new-button" onClick={handleNewNote}>
                    + New Note
                </Button>}
            </div>
        </div>
    );
};

export default SidebarNotes;
